'use client';

import type { JSX } from 'react';
import type { ParagraphType } from '../../../../interfaces';
import type { CmsData } from '../../../../interfaces/webapp_json';
import { useContentFilters } from '../../../hooks/useContentFilters';
import { ComponentRecognizer } from '../../ComponentRecognizer/ComponentRecognizer.client';
import type { FooterBlockType } from '../types';

type AreaTopProps = {
  data: CmsData;
};

export const AreaTop = ({ data }: AreaTopProps): JSX.Element => {
  const filters = useContentFilters();
  const comp = (data.paragraph as FooterBlockType[])
    .filter(
      (item) =>
        item?.parent_field_name === 'field_footer_top' && filters.every((filter) => filter(item)),
    )
    .map((item: ParagraphType, index) => (
      <ComponentRecognizer
        // eslint-disable-next-line react/no-array-index-key
        key={`top-item-${index}`}
        item={{ ...item, ...{ trackOnLoad: true } }}
      />
    ));

  if (comp.length === 0) {
    return <div className="mt-5" />;
  }

  return <div className="mx-auto max-w-screen-xl px-1 xl:px-0">{comp}</div>;
};
